import {
  BackgroundConfig,
  backgroundImageUrls,
  CustomBackgroundType,
} from 'components/signaturePreview/meeting/core/helpers/backgroundHelper';
import { atom } from 'recoil';
import {
  TabValue,
  LeftTabValue,
  RightTabValue,
  Details,
  MeetingDetails,
  Styles,
  MeetingStyles,
  VerifyStatus,
} from '../_modal/signatureModal';
import { meetingDetailsInitial, detailsInitial } from './signatureDefaultValues';
import { SourceConfig } from 'components/signaturePreview/meeting/core/helpers/sourceHelper';

const tabValueAtom = atom<TabValue>({
  key: 'tabValue',
  default: window.location.pathname === '/v-card' ? 'Virtual Background' : 'Email Signature',
});

const leftTabValueAtom = atom<LeftTabValue>({
  key: 'leftTabValue',
  default: 'Templates',
});

const rightTabValueAtom = atom<RightTabValue>({
  key: 'rightTabValue',
  default: 'Colors',
  // default: window.location.pathname === '/v-card' ? 'Virtual Background' : 'Email Signature',
});

const leftMenuAtom = atom<Boolean>({
  key: 'leftMenu',
  default: false,
});

const rightMenuAtom = atom<Boolean>({
  key: 'rightMenu',
  default: false,
});

const templateAtom = atom<string>({
  key: 'template',
  default: 'simple',
});
const meetingTemplateAtom = atom<string>({
  key: 'meetingTemplate',
  default: 'template1',
});

const detailsAtom = atom<Details>({
  key: 'details',
  default: {
    personalInfo: {
      ...detailsInitial.personalInfo,
    },
    contactInfo: {
      ...detailsInitial.contactInfo,
    },
    socialMedialLinks: {
      ...detailsInitial.socialMedialLinks,
    },
  },
});

const meetingDetailsAtom = atom<MeetingDetails>({
  key: 'meetingDetails',
  default: {
    personalInfo: {
      ...meetingDetailsInitial.personalInfo,
    },
    contactInfo: {
      ...meetingDetailsInitial.contactInfo,
    },
    socialMedialLinks: {
      ...meetingDetailsInitial.socialMedialLinks,
    },
  },
});

const stylesAtom = atom<Styles>({
  key: 'styles',
  default: {
    fontFamily: 'Verdana, sans-serif',
    fontSize: 13,
    yourNameColor: '#000000',
    textColor: '#000000',
    linkColor: '#000000',
    themeColor: '#000000',
  },
});

const meetingStylesAtom = atom<MeetingStyles>({
  key: 'meetingStyles',
  default: {
    fontFamily: 'Verdana, sans-serif',
    fontSize: 13,
    yourNameColor: '#ffffff',
    textColor: '#ffffff',
  },
});

const verifyStatusAtom = atom<VerifyStatus>({
  key: 'verifyStatus',
  default: {
    data: '',
    status: null,
    payload: null,
  },
});

const mailStatusAtom = atom<VerifyStatus>({
  key: 'mailStatus',
  default: {
    data: '',
    status: null,
    payload: null,
  },
});

const sourceConfigAtom = atom<SourceConfig>({
  key: 'sourceConfig',
  default: {
    type: 'image',
    url: '',
  },
});

const backgroundConfigAtom = atom<BackgroundConfig>({
  key: 'backgroundConfig',
  default: {
    type: 'image',
    url: backgroundImageUrls[0],
  },
});

const customBackgroundsAtom = atom<CustomBackgroundType>({
  key: 'customBackgrounds',
  default: [],
});

export {
  tabValueAtom,
  leftTabValueAtom,
  rightTabValueAtom,
  leftMenuAtom,
  rightMenuAtom,
  templateAtom,
  detailsAtom,
  stylesAtom,
  verifyStatusAtom,
  mailStatusAtom,
  meetingTemplateAtom,
  meetingDetailsAtom,
  meetingStylesAtom,
  sourceConfigAtom,
  backgroundConfigAtom,
  customBackgroundsAtom,
};
